import React from 'react';
import { Tooltip } from '@material-ui/core';
import {
  Container,
  Title,
  Statistics,
  ResendStats,
  Bold,
  ArrowUpIcon,
  ArrowDownIcon,
  Row,
  Column,
  Value,
  EmptySpace,
} from './Card.styled';
import { DeliveryRateIcon } from '../../SVGs/Icons';
import { CANCELLED, SCHEDULED } from '../../constants';

const Card = ({
  name,
  value,
  title,
  onClick = null,
  isDataAvailable,
  isSmartResendAvailable,
  smartResendValue,
  showComparativeAnalytics,
  Icon,
  messageStatus,
  stats,
  smartResendStats,
  isMessageCancelled,
  hasMessageSmartResend,
}) => {
  const isNotZero = value => {
    return value !== '0%' && value !== '0.0%' && value !== 0 && value !== null;
  };

  const isIncreasedInValue =
    smartResendValue && !String(smartResendValue).startsWith('-');

  const renderIncrease = (
    <>
      <ArrowUpIcon />
      <Bold>+{smartResendValue}</Bold>
      from resend ({smartResendStats})
    </>
  );

  const renderDecrease = (
    <>
      <ArrowDownIcon />
      <Bold>{smartResendValue}</Bold>
      from resend ({smartResendStats})
    </>
  );

  const getStatFontSize = () => {
    if (messageStatus === CANCELLED || messageStatus === SCHEDULED) {
      return '20px';
    }
    return '34px';
  };

  const getStatValue = () => {
    if (isMessageCancelled && !hasMessageSmartResend) {
      return 'No data';
    }
    if (messageStatus === SCHEDULED) {
      return 'No data yet';
    }
    return isDataAvailable ? value : '---';
  };

  const shouldHideStats =
    (isMessageCancelled && !hasMessageSmartResend) ||
    messageStatus === SCHEDULED;

  return (
    <Tooltip title={title} placement="top" style={{ justifyContent: 'center' }}>
      <Container onClick={onClick}>
        <Title>{name}</Title>
        <Column>
          <Row>
            {Icon ? <Icon /> : <DeliveryRateIcon />}
            <Statistics fontSize={getStatFontSize()}>
              {getStatValue()}
            </Statistics>
          </Row>
          {isSmartResendAvailable && (
            <ResendStats>
              {isNotZero(smartResendValue) ? (
                showComparativeAnalytics ? (
                  isIncreasedInValue ? (
                    renderIncrease
                  ) : (
                    renderDecrease
                  )
                ) : (
                  <>
                    Resend: <Bold> {smartResendValue}</Bold> ({smartResendStats}
                    )
                  </>
                )
              ) : (
                <>no change from resend</>
              )}
            </ResendStats>
          )}
        </Column>
        {shouldHideStats ? <EmptySpace /> : <Value>{stats || '0'}</Value>}
      </Container>
    </Tooltip>
  );
};

export default Card;
